export default __webpack_public_path__ + "static/media/formationtheburningstandard.08ed26eb.png";